import React from 'react';
import {Modal} from 'antd';
import TextLoader from '../../components/ContentLoaders/TextLoader';
import TableSettingsButton from '../../components/pages/SubscriptionsPage/TableSettingsButton';
import {objectHelpers} from './object.helpers';


export const elementHelpers = {
  getClassName: (cName, className) => {
    if (className) cName += ` ${className}`;
    return cName;
  },
  getElementOffsetTop: (elementId, parentsCount = 0) => {
    let element = document.querySelector(elementId);
    let offsetTop = element?.offsetTop || 0;
    if (parentsCount && parentsCount > 0) {
      for (let i = 0; i < parentsCount; i++) {
        if (element && element.offsetParent) {
          element = element.offsetParent;
          offsetTop += element.offsetTop;
        }
      }
    }
    return offsetTop;
  },
  getAvailableTableColumns: ({
    alwaysAvailableColumnKeys = [],
    columns = [],
    selectedColumns = []
  }) => {
    const columnKeys = [...selectedColumns, ...alwaysAvailableColumnKeys];
    return columns.filter(column => columnKeys.includes(column?.dataIndex));
  },
  getSettingsRightSideContent: ({
    alwaysAvailableColumnKeys = [],
    columns = [],
    onChange,
    selectedKeys,
    rightSideContent,
  }) => {
    columns = columns.filter(column => !alwaysAvailableColumnKeys.includes(column.dataIndex));
    return (
      <TableSettingsButton
        defaultSelectedKeys={selectedKeys}
        options={columns.map(c => ({value: c.dataIndex, label: c.title}))}
        onChange={onChange}
      >
        {rightSideContent}
      </TableSettingsButton>
    )
  },
  getVisibleClassName: (className = undefined, isVisible = false) => {
    let cName = 'form-step-container';
    if (className) cName += ` ${className}`;
    if (!isVisible) cName += ' form-d-none';
    return cName;
  },
  showConfirmModal: ({translate, ...rest}) => {
    Modal.confirm({
      cancelText: translate('no'),
      cancelButtonProps: {size: 'large'},
      centered: true,
      okButtonProps: {size: 'large', type: 'primary'},
      okText: translate('yes'),
      ...rest
    });
  },
  showContentWithLoader: (isEnable, content, loader = <TextLoader />) => isEnable ? content : loader,
  stopPropagation: (event) => event && event.stopPropagation(),
  updateMenuItems: ({ location, items, selectedKeys, setSelectedKeys }) => {
    let updatedSelectedKeys = [];

    for (let parent of items) {
      // Match parent item
      if (parent.path === location.pathname) {
        updatedSelectedKeys = [parent.key];
        break;
      }

      // Match child items (if they exist)
      if (Array.isArray(parent.children)) {
        for (let child of parent.children) {
          const normalizePath = (p) => (p ? p.replace(/\/+$/, '') : '');
          const childPath = normalizePath(child.path);
          const currentPath = normalizePath(location.pathname);
          if (childPath && (currentPath === childPath || currentPath.startsWith(childPath + '/'))) {
            updatedSelectedKeys = [parent.key, child.key];
            break;
          }
        }

        if (updatedSelectedKeys.length > 0) {
          break;
        }
      }
    }

    // Only update if changed
    if (!objectHelpers.arraysIsEqual(updatedSelectedKeys, selectedKeys)) {
      setSelectedKeys(updatedSelectedKeys);
    }
  },
  isInputOrButtonElement: (element) => {
    const tagNames = ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON'];
    return (element && tagNames.includes(element?.target?.tagName)) || element?.target?.closest('.ant-select-dropdown');
  }
}
